import React from 'react';
import { startCase, toLower } from 'lodash';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import styles from './ShippingAddress.module.scss';
import { AddressFormState } from './hooks/useHandleFormInput';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { doesCountryCodeHaveStates, getCountryNameFromCountryCode } from './shippingAddressUtils';

function AddressDisplay() {
  const { countries } = useAppContext();
  const { friend } = useFriendContext();
  const { address } = friend;

  function formatAddress(userAddress: AddressFormState) {
    const {
      shipAddress1, shipAddress2, shipCity, shipCountry, shipState, shipZipCode,
    } = userAddress;
    return (
      <>
        <p data-testid="displayShipAddress1">{startCase(toLower(shipAddress1))}</p>
        {shipAddress2 && <p>{startCase(toLower(shipAddress2))}</p>}
        <p>
          {startCase(toLower(shipCity))}
          {doesCountryCodeHaveStates(shipCountry, countries) && ','}
          {' '}
          {shipState}
          {!doesCountryCodeHaveStates(shipCountry, countries) && <br />}
          {' '}
          {shipZipCode}
        </p>
        <p>{getCountryNameFromCountryCode(shipCountry, countries)}</p>
      </>
    );
  }

  return (
    <div className={styles.addressDisplayContainer} data-testid="addressDisplay">
      <div>
        <p>
          {friend.firstName}
          {' '}
          {friend.lastName}
        </p>
        {formatAddress(address)}
      </div>
    </div>
  );
}

export default AddressDisplay;
